import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  DialogContentText
} from '@material-ui/core';
import { useSelector, useDispatch } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { iRootState, Dispatch } from '../redux/store';
import FeedbackFromEntry from './FeedbackFromEmailEntry';
import FeedbackFromEntryName from './FeedbackFromNameEntry';
import FeedbackEntry from './FeedbackEntry';
import ConfirmFeedback from './ConfirmFeedback';
import { QuoteStatuses, DialogNames, AnalyticsEventKeys } from '../constants';

const SendFeedbackDialog = function SendFeedbackDialog(): React.ReactElement {
  const dialogName = useSelector(
    (state: iRootState) => state.dialog.openDialog
  );

  const quoteState = useSelector((state: iRootState) => state.quote);
  const { status } = quoteState;

  function getDialogTitleId() {
    switch (status) {
      case QuoteStatuses.Accepted:
        return 'acceptandsign';
      case QuoteStatuses.ChangesRequested:
        return 'requestchanges';
      default:
        return 'decline';
    }
  }

  function getDialogTitleDefaultMessage() {
    switch (status) {
      case QuoteStatuses.Accepted:
        return 'Accept and Sign';
      case QuoteStatuses.ChangesRequested:
        return 'Request Changes';
      default:
        return 'Decline';
    }
  }

  function getAnalyticsEventKey() {
    switch (status) {
      case QuoteStatuses.Accepted:
        return AnalyticsEventKeys.AcceptCancelClicked;
      case QuoteStatuses.ChangesRequested:
        return AnalyticsEventKeys.RequestChangesClicked;
      default:
        return AnalyticsEventKeys.DeclineCancelClicked;
    }
  }

  const analyticsEventKey = getAnalyticsEventKey();
  const dialogTitleId = getDialogTitleId();
  const dialogTitleDefaultMessage = getDialogTitleDefaultMessage();

  const title = useSelector((state: iRootState) => state.quote.title);

  const { submitError, sending } = useSelector(
    (state: iRootState) => state.feedback
  );

  const open = dialogName === DialogNames.SendFeedback;

  const dispatch = useDispatch<Dispatch>();

  const onClickCancel = function handleOnClick(): void {
    dispatch.analytics.sendEvent({
      eventType: analyticsEventKey
    });
    dispatch.dialog.setOpenDialog('');
    dispatch.quote.setQuoteStatus('', undefined);
    dispatch.feedback.resetFeedback();
  };

  return (
    <Dialog open={open} fullWidth>
      <DialogTitle>
        <FormattedMessage
          id={dialogTitleId}
          defaultMessage={dialogTitleDefaultMessage}
        />
        &nbsp;
        {status !== QuoteStatuses.ChangesRequested && title}
      </DialogTitle>
      <DialogContent>
        <FeedbackFromEntryName />
        <FeedbackFromEntry />
        {status === QuoteStatuses.Accepted ? <p>&nbsp;</p> : <FeedbackEntry />}
      </DialogContent>
      <DialogActions>
        <ConfirmFeedback />
        <Button
          className='cancel'
          onClick={onClickCancel}
          color='primary'
          variant='outlined'
          disabled={sending}
        >
          <FormattedMessage id='cancel' defaultMessage='Cancel' />
        </Button>
      </DialogActions>
      <DialogContent>
        <DialogContentText color='error'>
          {submitError && (
            <FormattedMessage id={submitError} defaultMessage='' />
          )}
        </DialogContentText>
      </DialogContent>
    </Dialog>
  );
};

export default SendFeedbackDialog;
